import { createId } from '@paralleldrive/cuid2';
import styled from 'styled-components';

import { Shelf } from '@/types/Configuration';
import { Flex } from '@/ui/Flex/Flex';

import { AddButton } from '../../AddButton/AddButton';
import { TableCell } from '../TableCell/TableCell';

type StyledShelfExtraProps = { readonly height: number };

const StyledShelf = styled.div<StyledShelfExtraProps>`
  height: ${({ height }) => `${height}px`};
`;

type Props = {
  readonly saveShelves: (shelves: readonly Shelf[]) => void;
  readonly shelves: readonly Shelf[];
  readonly subsidiaryId: string;
  readonly unitId: string;
  readonly customerId: string;
};

const ADD_BUTTON_HEIGHT = 30;
const NAME_LABEL_HEIGHT = 21;
const SHELF_GAP = 16;

export const ShelfColumn = ({
  saveShelves,
  shelves,
  subsidiaryId,
  unitId,
  customerId,
}: Props) => (
  <Flex direction="column" gap={16}>
    {shelves.map((shelf) => (
      <StyledShelf
        height={
          shelf.players.length * (NAME_LABEL_HEIGHT + SHELF_GAP) +
          ADD_BUTTON_HEIGHT
        }
        key={shelf.id}
      >
        <TableCell
          columnName="Shelf"
          item={shelf.name}
          onDelete={() => {
            const newShelves = shelves.filter(
              ({ id: shelfId }) => shelfId !== shelf.id,
            );

            saveShelves(newShelves);
          }}
          onEdit={(shelfName) => {
            const newShelves = shelves.map((editShelf) =>
              editShelf.id === shelf.id
                ? { ...editShelf, name: shelfName }
                : editShelf,
            );

            saveShelves(newShelves);
          }}
        />
      </StyledShelf>
    ))}

    <AddButton
      columnName="Shelf"
      onSave={(shelfName) => {
        saveShelves([
          ...shelves,
          {
            id: createId(),
            customer: customerId,
            archived: false,
            name: shelfName,
            sensorBoxes: [],
            unitId,
            subsidiary: subsidiaryId,
            players: [],
          },
        ]);
      }}
    />
  </Flex>
);
